// swiperjs sliders
import './js/hero-slider';
import './js/hero-video';
import './js/front-swiper';

// modal video
import 'modal-video/css/modal-video.min.css'
import ModalVideo from 'modal-video';


// front hero resize, to enable div over div effect on scroll
// only active on front page
(function($) {

    $('.front-procedures__single').click(function(e){

        // disable on desktop
        if ( $('.mobile-nav').css('display') === 'none' ) {
            return;
        }

        if ( !$(this).hasClass('clicked') ) {
            e.preventDefault();
            $('.front-procedures__single').each(function() {
                $(this).removeClass('clicked');
            })
            $(this).toggleClass('clicked')
            return;
        }
    });


    // set modals
    new ModalVideo('.video-modal-youtube',
      { channel: 'youtube',
          youtube: {
            rel: 0
          }
      }
    );
    new ModalVideo('.video-modal-vimeo',
      { channel: 'vimeo' }
    );



})( jQuery );



